"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var AnimationsListenerCreator_1 = require("../../animations/AnimationsListenerCreator");
var GameContext_1 = require("../../GameProvider/GameContext");
var gameMiddleware_1 = __importDefault(require("../../Store/gameMiddleware"));
var gameReducer_1 = __importDefault(require("../../Store/gameReducer"));
var ConsoleTools_1 = __importDefault(require("./ConsoleTools"));
var GameLocalAPI_1 = __importDefault(require("./GameLocalAPI"));
function LocalGameProvider(_a) {
    var children = _a.children;
    var context = (0, react_1.useContext)(GameContext_1.gameContext);
    var store = (0, react_1.useMemo)(function () { return createLocalApiStore(context); }, []);
    return ((0, jsx_runtime_1.jsx)(react_redux_1.Provider, __assign({ store: store }, { children: children })));
}
exports.default = LocalGameProvider;
function createLocalApiStore(context) {
    var _a;
    var api = new GameLocalAPI_1.default(context);
    var Rules = (_a = context.RulesView) !== null && _a !== void 0 ? _a : context.Rules;
    var reducer = (0, gameReducer_1.default)(Rules, context.animations);
    var store = (0, redux_1.createStore)(reducer, (0, redux_1.applyMiddleware)((0, gameMiddleware_1.default)(api, Rules)));
    store.subscribe((0, AnimationsListenerCreator_1.createAnimationsListener)(store));
    if (process.env.NODE_ENV === 'development') {
        window.game = (0, ConsoleTools_1.default)(api, store);
    }
    api.init(store.dispatch);
    return store;
}
//# sourceMappingURL=LocalGameProvider.js.map